import * as React from 'react';
import { CreateWedding } from '../CreateWedding';
import { Helmet } from 'react-helmet';
import { withPaletteHydration } from '../CreateWeddingHydration';
import queryString from 'query-string';
import { Box } from '@withjoy/joykit';
import { withRouter, RouteComponentProps } from 'react-router';
import { getMarketingEnv } from 'utils/getJoyEnv';
import { getCtaText } from './utils';

const ctaText = getCtaText();

const CreateWeddingComponent: React.SFC<RouteComponentProps> = ({ location, history }) => {
  const WrappedCreateWedding = withPaletteHydration(CreateWedding);
  const values = queryString.parse(location.search);
  const emptyObj = Object.entries(values).length === 0;
  const url = getMarketingEnv(window.joyEnv);

  return (
    <>
      <Helmet>
        <title>Create your Joy Event</title>
        <style type="text/css">
          {`
          html {
            font-size: 16px;
          }
          body {
            font-size: 1rem;
          }
        `}
        </style>
      </Helmet>
      <Box paddingY="40px" paddingX={{ xs: 24, sm: 40 }}>
        {!emptyObj ? (
          <WrappedCreateWedding
            ctaText={ctaText}
            shouldHydrateStateFromSearch={true}
            onHeaderClick={() => history.push('/designs')}
          />
        ) : (
          <CreateWedding onHeaderClick={() => (window.location.href = url)} ctaText={ctaText} />
        )}
      </Box>
    </>
  );
};

export const CreateWeddingWrapper = withRouter(CreateWeddingComponent);
